module.exports = __webpack_public_path__ + "static/media/phone.14ba8cf5.png";